import { logger, LogTag } from '@/config/logger'
import Cookies from 'js-cookie'
import * as Def from './HomeModuleDef'

export class ProcessingResult {
  userId: string | undefined
  jobId: string | undefined
  fileName: string | undefined
  processingIsoDate: string | undefined
  iasUrl: string | undefined

  constructor({
    userId,
    jobId,
    fileName,
    iasUrl,
    processingIsoDate,
  }: {
    userId?: string
    jobId?: string
    fileName?: string
    iasUrl?: string
    processingIsoDate?: string
  }) {
    this.userId = userId
    this.jobId = jobId
    this.fileName = fileName
    this.iasUrl = iasUrl
    this.processingIsoDate = processingIsoDate
  }

  isComplete() {
    return false
  }

  hasProcessingJob() {
    return this.jobId != undefined
  }

  isResultDownloadAvailable() {
    return false
  }

  setOrRemoveCookie(key: string, value: any) {
    if (value !== undefined && value !== null) {
      Cookies.set(key, String(value), { expires: Def.COOKIE_LIFETIME })
    } else {
      Cookies.remove(key)
    }
  }

  save() {
    this.setOrRemoveCookie(Def.COOKIE_USER_ID, this.userId)
  }

  load() {
    this.userId = Cookies.get(Def.COOKIE_USER_ID)
  }

  static cleanSavedData() {
    Cookies.remove(Def.COOKIE_USER_ID)
  }

  getSavedJobId(): string | undefined {
    logger.warning(
      LogTag.HomePage,
      'Calling ProcessingResult.getSavedJobId():',
      'must be overridden by inherited class.'
    )
    return undefined
  }

  setDebugData() {
    const now = new Date()
    this.processingIsoDate = now.toISOString()

    this.userId = Cookies.get(Def.COOKIE_USER_ID)
    this.jobId = 'ABCDEF123344556'
    this.fileName = `simulated file with long name-0201340-2342,
      simulated file with long name-0201340-2342.wav`
    this.iasUrl = 'ias://debug_test'
  }
}
